import axiosClient from "./axiosClient";
import https from "https";

import ConstData from "../ConstData";

let options = {};

if (ConstData.IS_LOCAL_VERSION) {
    options = {
        httpsAgent: new https.Agent({
            rejectUnauthorized: false, // 허가되지 않은 인증을 reject하지 않겠다!
        })
    }
}

export const get_lite_server_list = () => {
    // console.log("api get lite server list:) ");

    return axiosClient.get(`/lite-local`, options);
}

export const create_lite_server = ({ liteServerName, liteServerMemo }) => {
    console.log("api create lite server:) liteServerName[", liteServerName, "], liteServerMemo[", liteServerMemo, "]");

    let data = {};

    if (liteServerName !== undefined && liteServerName !== null) {
        data.liteServerName = liteServerName;
    }

    if (liteServerMemo !== undefined && liteServerMemo !== null) {
        data.liteServerMemo = liteServerMemo;
    }

    return axiosClient.post(`/lite-local`, data, options);
}

export const remove_lite_server = ({ authCode }) => {
    console.log("api remove lite server:) authCode[", authCode, "]");

    return axiosClient.delete(`/lite-local`, {
        authCode
    }, options);
}

export const change_lite_server_info = ({ kind, authCode, liteServerMemo, liteServerName, initStatus }) => {
    console.log("api change lite server info:) kind[", kind, "], authCode[", authCode, "], initStatus[", initStatus, "]");
    console.log("api change lite server info:) liteServerMemo[", liteServerMemo, "], liteServerName[", liteServerName, "]");

    let data = {};

    if (liteServerMemo !== "") {
        data.liteServerMemo = liteServerMemo;
    }

    // 20260828 kind가 modifyName(이름 인라인 수정)일 때 이름값을 함께 전달한다.
    if (liteServerName !== undefined && liteServerName !== null && liteServerName !== "") {
        data.liteServerName = liteServerName;
    }

    if (initStatus !== undefined && initStatus !== null) {
        data.initStatus = initStatus;
    }

    return axiosClient.put(`/lite-local/${authCode}/server-admin?kind=${kind}`, data, options);
}